'use client';

import { type FC, useRef } from 'react';
import { BottomSheet } from '../../components/ui';
import { ContractInventoryList } from './ContractInventoryList';
import { useLocalTranslation } from '../../hooks/useLocalTranslation.ts';
import type { UserInventoryItemResponse } from '../../services/api.ts';
import translations from './ContractScreen.translations.ts';

interface ContractInventorySheetProps {
  isOpen: boolean;
  onClose: () => void;
  selectedIds: Set<string>;
  maxItems: number;
  onToggle: (item: UserInventoryItemResponse) => void;
}

export const ContractInventorySheet: FC<ContractInventorySheetProps> = ({
  isOpen,
  onClose,
  selectedIds,
  maxItems,
  onToggle,
}) => {
  const { t } = useLocalTranslation(translations);
  const scrollRef = useRef<HTMLDivElement | null>(null);

  return (
    <BottomSheet
      isOpen={isOpen}
      onClose={onClose}
      title={t('selectItemsSheetTitle')}
      subtitle={`${selectedIds.size}/${maxItems}`}
      onDone={onClose}
      doneAriaLabel={t('sheetDone')}
      closeAriaLabel={t('sheetClose')}
      scrollRef={scrollRef}
    >
      <ContractInventoryList
        selectedIds={selectedIds}
        maxItems={maxItems}
        onToggle={onToggle}
        scrollRef={scrollRef}
      />
    </BottomSheet>
  );
};
